import { Box, Card, CardContent, Typography, styled } from "@mui/material"

const imgSrc = "https://static-01.s3.fr-par.scw.cloud/pharmupp/messaging/logo.jpg"

export const ChatErrorContent = () => {
  return (
    <Card sx={{ backgroundColor: (theme) => theme.palette.grey[50], width: 400 }}>
      <CardContent>
        <Box>
          <Typography textAlign="center" lineHeight="22px">
            Réessayez plus tard
            <br />
            ou contactez l'ADV via le Chat
            <br />
            si le problème persiste.
          </Typography>
        </Box>
        <Img src={imgSrc} alt="" />
      </CardContent>
    </Card>
  )
}

const Img = styled("img")(({ theme }) => ({
  display: "block",
  borderRadius: "25px",
  width: "75px",
  aspectRatio: "1/1",
  marginInline: "auto",
  marginTop: theme.spacing(3),
}))
